import React from "react";
import { Button } from "../../Button";
import { ReactComponent as IconShare } from "../../assets/img/arrow-with-stem-pointing-up-right.svg";
import "./dictationMessage.css";

export const DictationMessage: React.FC = () => {
    const IconShareSVG = <IconShare />;
    return (
        <>
            <h2 className="type--heading-1">How to dictate on your device</h2>
            <p className="type--body--large">
                All major computing platforms have the ability to dictate into text fields. See 
                how on
                your device:
            </p>
            <div className="helper-list">
                <div className="helper-list__item">
                    <h3 className="type--body--large">iPhone &amp; iPad</h3>
                    <a
                        href="https://support.apple.com/guide/iphone/dictate-text-iph2c0651d2/
                        ios"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button
                            label="View Apple FAQ"
                            buttonTitle="View Apple FAQ"
                            buttonType="utility"
                            size="small"
                            trailingIcon={IconShareSVG}
                            onClick={() => console.log("open")}
                        />
                    </a>
                </div>
                <div className="helper-list__item">
                    <h3 className="type--body--large">Android</h3>
                    <a
                        href="https://support.google.com/gboard/answer/2781851?hl=en&co=GENIE.
                        Platform%3DAndroid"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button
                            label="View Android FAQ"
                            buttonTitle="View Android FAQ"
                            buttonType="utility"
                            size="small"
                            trailingIcon={IconShareSVG}
                            onClick={() => console.log("open")}
                        />
                    </a>
                </div>
                <div className="helper-list__item">
                    <h3 className="type--body--large">Mac</h3>
                    <a
                        href="https://support.apple.com/guide/mac-help/use-dictation-mh40584/mac"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button
                            label="View Apple FAQ"
                            buttonTitle="View Apple FAQ"
                            buttonType="utility"
                            size="small"
                            trailingIcon={IconShareSVG}
                            onClick={() => console.log("open")}
                        />
                    </a>
                </div>
                <div className="helper-list__item">
                    <h3 className="type--body--large">Windows</h3>
                    <a
                        href="https://support.microsoft.com/en-us/windows/
                        dictate-text-using-speech-recognition-854ef1de-7041-9482-d755-8fdf2126ef2
                        7"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <Button
                            label="View Windows FAQ"
                            buttonTitle="View Windows FAQ"
                            buttonType="utility"
                            size="small"
                            trailingIcon={IconShareSVG}
                            onClick={() => console.log("open")}
                        />
                    </a>
                </div>
            </div>
        </>
    );
};
